import { apiClient, API_CONFIG } from '../config/api'
import { Asset, AssetRequest, AssetResponse } from '../types/asset'

const BM = API_CONFIG.BM_BASE_URL

export const assetService = {
  async getAssets(): Promise<AssetResponse> {
    const { data } = await apiClient.get(`${BM}/assets`)
    return data
  },

  async getAsset(id: number) {
    const { data } = await apiClient.get(`${BM}/assets/${id}`)
    return data as { success: boolean; data: Asset }
  },

  async createAsset(asset: AssetRequest) {
    const { data } = await apiClient.post(`${BM}/assets`, asset)
    return data as { success: boolean; data: Asset }
  },

  async updateAsset(id: number, asset: AssetRequest) {
    const { data } = await apiClient.put(`${BM}/assets/${id}`, asset)
    return data as { success: boolean; data: Asset }
  },

  async deleteAsset(id: number) {
    const { data } = await apiClient.delete(`${BM}/assets/${id}`)
    return data as { success: boolean; message?: string }
  },

  async getCustomerAssets(customerId: number): Promise<AssetResponse> {
    const { data } = await apiClient.get(`${BM}/customers/${customerId}/assets`)
    return data
  },
}
